<template>
  <div class="card shadow-lg">
    <div class="card-header bg-transparent">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12">
          <div class="input-group input-group-lg">
            <span class="input-group-text text-body bg-transparent border-0">
              <i class="ni ni-zoom-split-in text-lg" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              class="form-control bg-transparent border-0"
              placeholder="Search anything..."
              onfocus="focused(this)"
              onfocusout="defocused(this)"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12 my-auto ms-auto">
          <div class="d-flex align-items-center">
            <i
              class="ni ni-headphones text-lg text-body ms-auto"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Headphones connected"
            ></i>
            <i
              class="ni ni-button-play text-lg text-body ms-3"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Music is playing"
            ></i>
            <i
              class="ni ni-button-power text-lg text-body ms-3"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Start radio"
            ></i>
            <i
              class="ni ni-watch-time text-lg text-body ms-3"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Time tracker"
            ></i>
            <h4 class="text-body mb-1 ms-4">10:45</h4>
          </div>
        </div>
      </div>
      <hr class="horizontal light" />
      <div class="row">
        <div class="col-lg-4 col-md-6 col-12">
          <div class="d-flex align-items-center position-relative">
            <h3 class="text-body mb-1">11:13</h3>
            <p class="text-body opacity-8 mb-1 ms-3">Estimated arrival time</p>
            <hr class="vertical light mt-0" />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <div class="d-flex align-items-center position-relative">
            <h3 class="text-body mb-1 ms-md-auto">
              2.4
              <small class="align-top text-sm">Km</small>
            </h3>
            <p class="text-body opacity-8 mb-1 ms-3 me-auto">
              Turn right in 2.4 miles
            </p>
            <hr class="vertical light mt-0" />
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12 ms-lg-auto">
          <div class="d-flex align-items-center">
            <h3 class="text-body mb-1 ms-lg-auto">
              6.3
              <small class="align-top text-sm">Km</small>
            </h3>
            <p class="text-body opacity-8 mb-1 ms-3">
              Distance to Creative Tim
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 py-0">
      
      <div class="google-map" ref="googleMap"></div>
      <template v-if="Boolean(this.google) && Boolean(this.map)">
        <slot
          :google="google"
          :map="map"
        />
      </template>


    </div>
    

    
  </div>
</template>
<style>
.google-map{

  height: 500px;
}
</style>
<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

export default {
  name: "PlayerCard",
  data() {
    return {
      map: null,
      google: null,
      tiles: [],
    };
  },
  async mounted() {
    
    

    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: "AIzaSyDrbKpz_7nbJey3xOS5rOXqpcyWBYI7ry0"
    })
    this.google = googleMapApi
    this.initializeMap()

    // Init slider
    // var slider = document.getElementById("sliderRegular");
    // noUiSlider.create(slider, {
    //   start: 40,
    //   connect: [true, false],
    //   range: {
    //     min: 0,
    //     max: 100
    //   }
    // });
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(
        mapContainer, {   
            clickableIcons: false,
            streetViewControl: false,
            panControlOptions: false,
            gestureHandling: "cooperative",
            mapTypeControl: true,
            zoomControlOptions: {
              style: "SMALL"
            },
            zoom: 5,
            minZoom: 2,
            maxZoom: 8, center: { lat: -23.1991964, lng: -46.8903755 }
        }
      )
    }
  },
};
</script>
